export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_21-EN-a7f4820172789980c199d37b4f86a7f1.webp";